import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { addItem } from "../api";
import { TextField, Button, MenuItem, Container, Paper, Typography } from "@mui/material";
import { v4 as uuidv4 } from "uuid";
import imageCompression from 'browser-image-compression';


const AddItem = () => {
  const { eventId } = useParams();
  const navigate = useNavigate();

  const [itemName, setItemName] = useState("");
  const [category1, setCategory1] = useState("食べ物");
  const [category2, setCategory2] = useState("");
  const [category3, setCategory3] = useState("");
  const [quantity, setQuantity] = useState(1);
  const [purchaseUrl, setPurchaseUrl] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageFile(file);
    }
  };

  const uploadImageToS3 = async (eventId, itemId, file) => {
    console.log("📦 アップロード開始");
    console.log("📁 オリジナルファイル名:", file.name);
    console.log("📄 タイプ:", file.type);
    console.log("📏 元サイズ:", file.size);
  
    // ✅ 圧縮設定（例：最大幅800px、品質80%）
    const options = {
      maxWidthOrHeight: 800,
      useWebWorker: true,
      initialQuality: 0.8,
    };
  
    const compressedFile = await imageCompression(file, options);
    console.log("✅ 圧縮後サイズ:", compressedFile.size);
  
    const res1 = await fetch("https://qt3zit1045.execute-api.ap-northeast-1.amazonaws.com/dev/getUploadUrl", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        eventId,
        itemId,
        fileType: compressedFile.type
      })
    });
  
    if (!res1.ok) {
      const errorText = await res1.text();
      console.error("❌ Presigned URL取得失敗:", errorText);
      throw new Error("Presigned URL取得に失敗しました");
    }
  
    const { uploadURL, imageUrl } = await res1.json();
    console.log("✅ Presigned URL:", uploadURL);
    console.log("✅ Image URL:", imageUrl);
  
    const res2 = await fetch(uploadURL, {
      method: "PUT",
      headers: {
        "Content-Type": compressedFile.type
      },
      body: compressedFile
    });
  
    if (!res2.ok) {
      const errorText = await res2.text();
      console.error("❌ S3アップロード失敗:", errorText);
      throw new Error("画像アップロードに失敗しました");
    }
  
    console.log("✅ アップロード成功！");
    return imageUrl;
  };
  

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsUploading(true);

    const finalCategory2 = category2.trim() === "" ? "Lv2カテゴリなし" : category2;
    const finalCategory3 = category3.trim() === "" ? "Lv3カテゴリなし" : category3;

    try {
      // const itemId = crypto.randomUUID(); // ← UUIDを生成
      const itemId = uuidv4();
      console.log("🆕 生成した itemId:", itemId);
      let imageUrl = undefined;

      if (imageFile) {
        imageUrl = await uploadImageToS3(eventId, itemId, imageFile);
      }

      console.log("📤 uploadImageToS3 に渡す itemId:", itemId);
      console.log("📸 imageUrl:", imageUrl);  

      console.log("✅ 送信前のデータ:", {
        itemName,
        category1,
        finalCategory2,
        finalCategory3,
        quantity,
        imageUrl
      });

      await addItem(
        eventId,
        itemId, // ✅ ← ここ追加
        itemName,
        category1,
        finalCategory2,
        finalCategory3,
        Number(quantity),
        imageUrl,
        purchaseUrl.trim() !== "" ? purchaseUrl : ""
      );

      console.log("✅ addItem に渡した itemId:", itemId);

      alert("品物を追加しました！");
      navigate(`/events/${eventId}`);
    } catch (error) {
      console.error("❌ エラー:", error);
      alert("エラーが発生しました。");
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <Container maxWidth="sm">
      <Paper elevation={3} style={{ padding: "20px", marginTop: "20px" }}>
        <Typography variant="h4" gutterBottom>品物を追加</Typography>
        <form onSubmit={handleSubmit}>
          <TextField label="品物名" fullWidth value={itemName} onChange={(e) => setItemName(e.target.value)} required margin="normal" />
          <TextField select label="カテゴリ1" fullWidth value={category1} onChange={(e) => setCategory1(e.target.value)} required margin="normal">
            <MenuItem value="食べ物">食べ物</MenuItem>
            <MenuItem value="飲み物">飲み物</MenuItem>
          </TextField>
          <TextField label="カテゴリ2" fullWidth value={category2} onChange={(e) => setCategory2(e.target.value)} margin="normal" placeholder="（未入力の場合、自動設定）" />
          <TextField label="カテゴリ3" fullWidth value={category3} onChange={(e) => setCategory3(e.target.value)} margin="normal" placeholder="（未入力の場合、自動設定）" />
          <TextField label="数量" type="number" fullWidth value={quantity} onChange={(e) => setQuantity(e.target.value)} required margin="normal" />
          <TextField label="参考URL" fullWidth value={purchaseUrl} onChange={(e) => setPurchaseUrl(e.target.value)} margin="normal" placeholder="参考URLを入力" />

          <div style={{ marginTop: "20px" }}>
            <Typography variant="body1">参考画像を選択：</Typography>
            <input type="file" accept="image/*" onChange={handleImageChange} />
          </div>

          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            style={{ marginTop: "20px" }}
            disabled={isUploading}
          >
            {isUploading ? "アップロード中..." : "登録"}
          </Button>

          <Button
            variant="outlined"
            color="secondary"
            fullWidth
            style={{ marginTop: "10px" }}
            onClick={() => navigate(`/events/${eventId}`)}
          >
            戻る
          </Button>
        </form>
      </Paper>
    </Container>
  );
};

export default AddItem;
